import { useAxeptio } from '@sortlist-frontend/user-tools';

import { DomainInfo } from '_backend/integration/domain-info';
import { Obfuscate } from '_components/common/Obfuscate/Obfuscate';
import { getUrlHelper } from '_components/layout/PrimaryNav/DesktopNav/utils';

import type { FooterProps } from './Footer';

export const Others = (props: FooterProps) => {
  const { t, navigationData, isStatic = false } = props;
  const { locale, origin } = navigationData;
  const linkProps = { obfuscate: !isStatic };

  const domainInfo = DomainInfo.getFromOrigin(origin);
  const getUrl = getUrlHelper(domainInfo, locale);

  const { openAxeptioCookieWidget } = useAxeptio();

  const handleManageCookiesClick = (e: React.MouseEvent) => {
    e.preventDefault();
    openAxeptioCookieWidget();
  };

  return (
    <ul
      data-testid="footer-bottom-links-container"
      className="m-0 flex flex-row flex-wrap list-none p-0 text-sm [&_*]:!text-secondary-500">
      <li>
        <span>{new Date().getFullYear()} © Sortlist</span>&nbsp;-&nbsp;
      </li>
      <li>
        <span>{t('common:footer.navigation.extra.right')}</span>&nbsp;-&nbsp;
      </li>
      <li>
        <Obfuscate href={getUrl('legal.terms')} {...linkProps}>
          {t('common:footer.navigation.extra.terms')}&nbsp;-&nbsp;
        </Obfuscate>
      </li>

      <li>
        <Obfuscate href={getUrl('legal.privacyPolicy')} {...linkProps}>
          {t('common:footer.navigation.extra.privacy')}
        </Obfuscate>
      </li>

      <li>
        <Obfuscate className="text-secondary-700" href={getUrl('legal.dpa')} {...linkProps}>
          &nbsp;-&nbsp;{t('common:footer.navigation.extra.dpa')}
        </Obfuscate>
      </li>

      {locale === 'de' && (
        <li>
          <Obfuscate href={getUrl('legal.impressum')} {...linkProps}>
            &nbsp;-&nbsp;{t('common:footer.navigation.extra.impressum')}
          </Obfuscate>
        </li>
      )}

      {isStatic ? null : (
        <li>
          <Obfuscate
            href="#"
            obfuscate={false}
            onClick={handleManageCookiesClick}
            role="button"
            aria-label={t('common:footer.navigation.extra.manageCookies')}
            data-testid="manage-cookies-link">
            &nbsp;-&nbsp;{t('common:footer.navigation.extra.manageCookies')}
          </Obfuscate>
        </li>
      )}
    </ul>
  );
};
